import React from "react";
import PropTypes from "prop-types";

import className from "../style.module.scss";

export function GridItem(props) {
  return (
    <div
      className={`${className.gridItem} ${props.type === "hidden" ? className.hidden : null} ${props.type === "cell" ? className.cell : null} ${props.type === "hotspot" ? className.hotspot : null} ${props.type === "entity" ? className.entity : null}`}
      role="presentation"
      style={{
        gridColumnStart: props.gridColumnStart,
        gridColumnEnd: props.gridColumnEnd,
        gridRowStart: props.gridRowStart,
        gridRowEnd: props.gridRowEnd,
        border: props.show ? "0.1vw solid rgba(255, 255, 255, 0.25)" : null,
        ...props.style,
      }}
    >
      {props.dev ? (
        <div
          className={className.devGridCoords}
          style={{
            fontSize: `calc(20vw / ${props.viewData.size.width})`,
          }}
        >
          {props.gridColumnStart},{props.gridRowStart}
        </div>
      ) : null}
      {props.children}
    </div>
  );
}

GridItem.propTypes = {
  type: PropTypes.oneOf(["cell", "hotspot", "entity", "hidden"]).isRequired,
  gridColumnStart: PropTypes.number.isRequired,
  gridColumnEnd: PropTypes.number.isRequired,
  gridRowStart: PropTypes.number.isRequired,
  gridRowEnd: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  viewData: PropTypes.object.isRequired,
  children: PropTypes.element,
  dev: PropTypes.bool,
  style: PropTypes.object,
};
GridItem.defaultProps = {
  dev: false,
  style: {},
};
